import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChevronRight } from 'lucide-react';
import ContactActionButtons from '../buttons/ContactActionButtons';
import HeroContent from './hero/HeroContent';
import dorperSheep from '@/assets/pexels-magda-ehlers-pexels-789468.webp';
import { productsPrefetchHandlers } from '@/utils/prefetchProductsRoute';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-hero w-full">
      <div className="absolute inset-0 bg-springbok-900/10"></div>
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative py-4 md:py-10">

        {/* Mobile layout: compact side-by-side */}
        <div className="flex sm:hidden items-start gap-3">
          <div className="flex-1 min-w-0">
            <h1 className="text-2xl font-bold text-springbok-800 leading-tight mb-2">
              Your Trusted Partner in Agriculture
            </h1>
            <Link to="/products" {...productsPrefetchHandlers}>
              <Button className="px-3 py-1.5 h-auto rounded-md text-sm" data-gradient="green">
                Shop Now <ChevronRight size={14} className="ml-1" />
              </Button>
            </Link>
          </div>
          <div className="w-32 flex-shrink-0">
            <div className="rounded-lg overflow-hidden shadow-lg h-32">
              <img
                src={dorperSheep}
                alt="Black head Dorper Sheep"
                width="128"
                height="128"
                className="w-full h-full object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>

        {/* Mobile: contact buttons below the side-by-side row */}
        <div className="flex sm:hidden mt-3">
          <ContactActionButtons />
        </div>

        {/* Desktop layout: full HeroContent + large image */}
        <div className="hidden sm:flex items-center gap-6">
          <div className="flex-1">
            <HeroContent />
          </div>
          <div className="w-64 md:w-72 lg:w-80 flex-shrink-0">
            <div className="rounded-lg overflow-hidden shadow-lg h-56 md:h-64">
              <img
                src={dorperSheep}
                alt="Black head Dorper Sheep"
                width="320"
                height="256"
                className="w-full h-full object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default HeroSection;
